export const intervention = {
    namespaced: true,
    state: {
        school: null,
        interventionTypeId: null,
        editBehaviorPlan: null,
        categoryId: null,
        interventionCompleted: false,
        schoolYear: null,
    },

    mutations: {
        set(state, payload) {
            state[payload.key] = payload.value
        }
    },
    getters: {
        interventionCompleted: state => state.interventionCompleted 
    }
}